import fs from "fs";

type Sitemap = {
  urlset?: {
    url?: {
      loc: string;
      [key: string]: string;
    }[];
  };
};

export const filterSitemap = (brand: string, sitemap: Sitemap): Sitemap => {
  // Fetched from GitLab Secure Files by the fetch_sitemap_whitelists CI job.
  const filePath = `./sitemap-whitelists/${brand.toLowerCase()}.txt`;

  if (!fs.existsSync(filePath) || !sitemap?.urlset?.url) {
    return sitemap;
  }

  const whitelist = new Set(
    fs
      .readFileSync(filePath, { encoding: "utf-8" })
      .split(/\s*\n\s*/)
      .filter(Boolean)
  );

  return {
    urlset: {
      url: sitemap.urlset.url.filter((url) => {
        const slug = url.loc.match(/(?<=institution-profiles\/).+(?=[.]html$)/)?.[0];

        return !!slug && whitelist.has(slug);
      }),
    },
  };
};
